import { isUnijayaEmail } from '@/services/emailScope.js';

const paparanUtama = {
    to     : 'paparanutama',
    icon   : 'mdi-home',
    text   : 'Paparan Utama',
};

const utamaDashboard = { 
    title: 'utama', 
    icon: 'mdi-view-dashboard', 
    url: `paparanutama`
};

// NOTA: setiap `icon` di bawah sepadan dengan ikon tajuk halaman destinasi
// (prop `icon` pada <PageHeader>, atau `amenity.icon` bagi Kemudahan Asas),
// supaya ikon menu dan ikon halaman sentiasa sama.
const julatHarga = {
    to     : 'julatharga',
    icon   : 'mdi-tag-multiple-outline',
    text   : 'Julat Harga',
};

// Audit Log — shown to every role the backend permits (BPM/BPHPP/ADMIN see all
// rows; PP/PO only their own negeri). See MODULE_POLICIES.auditLog.
const jejakAudit = {
    to     : 'audit-log',
    icon   : 'mdi-clipboard-text-clock',
    text   : 'Jejak Audit',
};

// Halaman penyelenggaraan sistem — bukan data tinjauan. Dikumpulkan supaya ia
// tidak berselerak di antara modul data pada aras atas menu.
//
// ADMIN mempunyai alat penyelenggaraan DATA (Pengurusan Lampiran, Wajaran) +
// Jejak Audit. Status Sambungan, Konfigurasi dan Migrasi Data BUKAN lagi milik
// ADMIN - ketiga-tiganya berpindah ke SUPERADMIN (lihat getSistemSuperadmin).
// Peranan lain hanya nampak Jejak Audit. Kumpulan dengan SATU anak sahaja
// ialah beban navigasi
// tanpa faedah — pengguna terpaksa buka kumpulan untuk sampai ke satu pautan —
// jadi bagi peranan itu kita pulangkan Jejak Audit sebagai item rata seperti
// sebelum ini. Kumpulan hanya terbentuk apabila memang ada lebih satu.
const getSistem = (isAdmin = false) => {
    if (!isAdmin) return jejakAudit;

    return {
        icon     : 'mdi-cog-outline',
        text     : 'Tetapan Sistem',
        // Susunan: alat penyelenggaraan DATA dahulu (yang paling kerap
        // digunakan), kemudian alat pentadbiran sistem. Jejak Audit diletak
        // selepas keduanya kerana ia dibaca selepas sesuatu berlaku, bukan
        // sebagai tempat kerja harian.
        //
        // Pengurusan Lampiran & Wajaran ialah alat PENYELENGGARAAN data, bukan
        // paparan data tinjauan: kedua-duanya menulis kembali ke jadual sumber
        // yang dibaca oleh Jadual Awalan. Mengumpulkannya di sini mengasingkan
        // "melihat data" daripada "mengubah data" — sebelum ini Pengurusan
        // Lampiran duduk sebagai anak terakhir Jadual Awalan (di sebelah
        // halaman baca-sahaja) dan Wajaran terapung sendirian pada aras atas.
        subLinks : [
            {
                to   : 'lampiran-manager',
                icon : 'mdi-table-cog',
                text : 'Pengurusan Lampiran',
            },
            {
                to   : 'wajaran',
                icon : 'mdi-chart-timeline-variant-shimmer',
                text : 'Pengurusan Wajaran',
            },
            jejakAudit,
        ]
    };
};

// Pengurusan Negeri & Daerah — SUPERADMIN sahaja. Ia menyunting jadual RUJUKAN
// (lookupnegeri + lampiran_daerah) yang dibaca oleh Jadual Awalan, Lampiran dan
// Wajaran, jadi satu kod yang salah menjejaskan setiap laporan. Kerana itu ia
// tidak diletak dalam getSistem() (yang dikongsi dengan ADMIN), sebaliknya
// disisip di sini — tepat DI BAWAH Wajaran, kerana ia jiran alat penyelenggaraan
// data itu dan bukan alat pentadbiran sistem seperti tiga yang di bawahnya.
const pengurusanNegeriDaerah = {
    to   : 'negeri-daerah',
    icon : 'mdi-map-marker-radius',
    text : 'Pengurusan Negeri & Daerah',
};

// Tetapan Sistem bagi SUPERADMIN: SEMUA yang ADMIN ada (Pengurusan Lampiran,
// Wajaran, Jejak Audit) DITAMBAH Pengurusan Negeri & Daerah dan tiga alat
// pentadbiran sistem yang hanya milik SUPERADMIN. Setiap laluan tambahan itu
// dikawal oleh MODULE_BY_PATH + policy SUPERADMIN dalam services/negeriScope.js,
// dan oleh requireSuperAdmin di backend.
const getSistemSuperadmin = () => {
    const sistemAdmin = getSistem(true);
    // Sisip selepas Wajaran, bukan di hujung: kedudukan dikira daripada `to`
    // supaya susunan kekal betul jika senarai ADMIN disusun semula kelak.
    const subLinks = [...sistemAdmin.subLinks];
    const iWajaran = subLinks.findIndex(l => l.to === 'wajaran');
    if (iWajaran === -1) subLinks.push(pengurusanNegeriDaerah);
    else subLinks.splice(iWajaran + 1, 0, pengurusanNegeriDaerah);

    return {
        ...sistemAdmin,
        subLinks : [
            ...subLinks,
            {
                to   : 'db-status',
                icon : 'mdi-lan-connect',
                text : 'Status Sambungan',
            },
            {
                to   : 'migrasi-data',
                icon : 'mdi-database-import',
                text : 'Migrasi Data',
            },
            {
                to   : 'config',
                icon : 'mdi-cog',
                text : 'Konfigurasi',
            },
        ]
    };
};

// Pengurusan Pengguna — SUPERADMIN only (ADMIN had it before the SUPERADMIN
// role existed). The endpoints behind it act on an arbitrary idpengguna
// (including role changes), so it is gated in all three places: here,
// MODULE_POLICIES.pengurusanPengguna (router guard) and adminOnly in the
// backend routes/penggunasistem.route.js.
// eslint-disable-next-line no-unused-vars
const getPengurusanPengguna = (tetapanText = 'Tetapan Penyelia') => ({
    icon     : 'mdi-account-multiple-plus',
    text     : 'Modul Pengurusan Pengguna',
    subLinks : [
        {
            text : 'Pengguna',
            to    : 'penggunasistem',
            icon : 'mdi-account-multiple-plus',
        },
        // "Tetapan Penyelia" disembunyikan - tidak diperlukan untuk sistem ini.
        // Laluan tetapkanpenyeliaprosesanoperasi masih wujud jika perlu diaktifkan semula.
        // {
        //     text: tetapanText,
        //     icon: 'mdi-account-arrow-right',
        //     to: `tetapkanpenyeliaprosesanoperasi`
        // },
    ]
});

const getPamerData = (role) => {
    const subLinks = [];
    // Pamer Data Hies: ADMIN / BPM / BPHPP only (mirrors ANALISIS_ROLES in
    // backend lib/analisis_penerbitan/analisisRoles.js). Other roles are sent to
    // Sistem HIES/BA Tangkapan Data instead.
    if (['ADMIN', 'SUPERADMIN', 'BPM', 'BPHPP'].includes(role)) {
        subLinks.push({
            text : 'Pamer Data HIES',
            to    : 'pamerdatahies',
            icon : 'mdi-file-table-box-multiple',
        });
    }
    // Validasi (Pamer Data): BPHPP / ADMIN only.
    if (['BPHPP', 'ADMIN', 'SUPERADMIN'].includes(role)) {
        subLinks.push({
            text : 'Validasi (Pamer Data)',
            to    : 'modulvalidasi',
            icon : 'mdi-shield-check',
        });
    }
    // Data Collapse HES: BPHPP / BPM / PP / PO / ADMIN (BPHPP & BPM get ONLY this one).
    if (['ADMIN', 'SUPERADMIN', 'BPHPP', 'BPM', 'PP', 'PO'].includes(role)) {
        subLinks.push({
            text : 'Data Collapse HES',
            to    : 'datacollapsehes',
            icon : 'mdi-table-arrow-down',
        });
    }

    return {
        icon     : 'mdi-tablet-dashboard',
        text     : 'Modul Pamer Data',
        subLinks
    };
};

const getJadualAwalan = () => {
    const subLinks = [
        {
            text : 'Kadar Respon',
            to   : 'kadarrespon',
            icon : 'mdi-chart-donut-variant',
        },
        {
            icon     : 'mdi-cash-multiple',
            text     : 'Pendapatan Isi Rumah Kasar',
            subLinks : [
                {
                    text : 'Bulanan Purata',
                    to   : 'pendapatanpurata',
                    icon : 'mdi-cash-multiple',
                },
                {
                    text : 'Bulanan Penengah',
                    to   : 'pendapatanpenengah',
                    icon : 'mdi-chart-bell-curve',
                },
                {
                    text : 'Purata & Penengah mengikut Kumpulan Etnik & Strata',
                    to   : 'pendapatankaumstrata',
                    icon : 'mdi-account-group-outline',
                },
                {
                    text : 'Purata & Penengah mengikut Daerah Pentadbiran & Strata',
                    to   : 'pendapatandaerahstrata',
                    icon : 'mdi-map-marker-radius-outline',
                },
            ]
        },
        {
            icon     : 'mdi-cart',
            text     : 'Perbelanjaan Isi Rumah',
            subLinks : [
                {
                    text : 'Bulanan Purata',
                    to   : 'perbelanjaanpurata',
                    icon : 'mdi-cart',
                },
                {
                    text : 'Mengikut Kumpulan Etnik & Strata',
                    to   : 'perbelanjaankaumstrata',
                    icon : 'mdi-account-group-outline',
                },
                {
                    text : 'Mengikut Daerah Pentadbiran & Strata',
                    to   : 'perbelanjaandaerahstrata',
                    icon : 'mdi-map-marker-radius-outline',
                },
                {
                    text : 'Komposisi Kumpulan Utama Perbelanjaan Isi Rumah Bulanan',
                    to   : 'perbelanjaankomposisi',
                    icon : 'mdi-chart-arc',
                },
            ]
        },
        {
            icon     : 'mdi-home-city',
            text     : 'Kemudahan Asas',
            subLinks : [
                {
                    text : 'Jenis Milikan Rumah (JMR)',
                    to   : 'jenismilikanrumah',
                    icon : 'mdi-home-account',
                },
                {
                    text : 'Bekalan Air',
                    to   : 'bekalanair',
                    icon : 'mdi-water-pump',
                },
                {
                    text : 'Bekalan Elektrik',
                    to   : 'bekalanelektrik',
                    icon : 'mdi-flash',
                },
                {
                    text : 'Kutipan Sampah',
                    to   : 'kutipansampah',
                    icon : 'mdi-trash-can',
                },
            ]
        },
    ];

    return {
        icon     : 'mdi-table-large',
        text     : 'Jadual Awalan',
        subLinks
    };
};

/**
 * Drop "Modul Pengurusan Pengguna" unless the email marks the user as internal
 * Unijaya staff. Currently a no-op: SUPERADMIN is the only role that builds the
 * group at all, so the email rule has nothing left to strip. Kept in place in
 * case the ".unijaya" check is switched back on. The ".unijaya" marker is also
 * what schema/superadmin-role.sql uses to pick which existing accounts get the
 * SUPERADMIN peranan.
 */
function stripPengurusanPengguna(menu, email) {
    // if (isUnijayaEmail(email)) return menu;
    // return menu.filter(m => !(m && m.text === 'Modul Pengurusan Pengguna'));
    return menu;
}

async function navsidebar(role, penerbitanPerms = [], email = null) {
    let menu;
    switch (role) {
        case 'BPHPP':
        case 'BPM':
            menu = [
                paparanUtama,
                getPamerData(role),
                julatHarga,
                getJadualAwalan(),
                getSistem()
            ];
            break;

        case 'PP':
            menu = [
                paparanUtama,
                getPamerData(role),
                julatHarga,
                getJadualAwalan(),
                getSistem()
            ];
            break;

        case 'SMD':
            menu = [
                utamaDashboard
            ];
            break;

        case 'PO':
            menu = [
                paparanUtama,
                getPamerData(role),
                julatHarga,
                getJadualAwalan(),
                getSistem()
            ];
            break;

        case 'FE':
        case 'DE':
            // FE/DE: Julat Harga only (no Jadual Awalan), scoped to their own negeri.
            menu = [
                paparanUtama,
                julatHarga
            ];
            break;

        case 'RESPONDENT':
        case 'PUBLIC':
            menu = [
                utamaDashboard
            ];
            break;

        case 'ADMIN':
            // Modul Pengurusan Pengguna sudah TIADA di sini — ia milik
            // SUPERADMIN, bersama Status Sambungan, Migrasi Data dan Konfigurasi.
            menu = [
                paparanUtama,
                getPamerData(role),
                julatHarga,
                getJadualAwalan(),
                getSistem(true)
            ];
            break;

        case 'SUPERADMIN':
            // Superset ADMIN: semua modul data yang ADMIN nampak, DITAMBAH
            // empat modul pentadbiran sistem (Modul Pengurusan Pengguna +
            // Status Sambungan / Migrasi Data / Konfigurasi dalam Tetapan
            // Sistem) yang telah dialih keluar daripada ADMIN.
            menu = [
                paparanUtama,
                getPengurusanPengguna('Tetapan Penyelia'),
                getPamerData(role),
                julatHarga,
                getJadualAwalan(),
                getSistemSuperadmin()
            ];
            break;

        default:
            alert('Tiada Role');
            return [];
    }

    return stripPengurusanPengguna(menu, email);
}

export default navsidebar;